export function validatePattern(pattern: RegExp, message: string) {
	return {
		validate: (value: string) =>
			value && !value.match(pattern) ? message : true,
	};
}
